import { AfterViewInit, Component } from '@angular/core';

declare global {
  interface Window {
    ULObject?: string;
    ul_widget?: any;
  }
}

@Component({
  selector: 'app-qa',
  standalone: true,
  imports: [],
  templateUrl: './qa.component.html',
  styleUrls: ['./qa.component.css']
})
export class QaComponent implements AfterViewInit {
  private readonly scriptId = 'userlocal-support-widget-script';
  private readonly scriptSrc = 'https://support-widget.userlocal.jp/chatbot.js';

  ngAfterViewInit(): void {
    this.prepareUserLocalWidget();
    this.loadScriptIfNeeded();
    this.initWidget();
  }

  private prepareUserLocalWidget(): void {
    if (window.ul_widget) {
      return;
    }

    window.ULObject = 'ul_widget';
    window.ul_widget = function (...args: any[]) {
      (window.ul_widget.q = window.ul_widget.q || []).push(args);
    };
    window.ul_widget.l = Date.now();
  }

  private loadScriptIfNeeded(): void {
    if (document.getElementById(this.scriptId)) {
      return;
    }

    const script = document.createElement('script');
    script.id = this.scriptId;
    script.async = true;
    script.src = this.scriptSrc;

    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode?.insertBefore(script, firstScript);
  }

  private initWidget(): void {
    window.ul_widget('init', {
      id: 'a65b66db8f6ee17a13fb',
      site_in: true,
      lg_id: ''
    });
  }
}
